import { useEffect, useState } from 'react';
import useMedia from '../hooks/useMedia';

export default function MediaPicker({ open, onClose, onSelect }) {
  const { listMedia } = useMedia();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) {
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError('');

    listMedia({ limit: 50 })
      .then((response) => {
        if (!cancelled) {
          setItems(response.items || []);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [listMedia, open]);

  if (!open) {
    return null;
  }

  return (
    <div className="modal-backdrop">
      <div className="modal large" style={{ maxWidth: '850px' }}>
        <div className="modal-header">
          <h3>Medium auswählen (Media Picker)</h3>
          <button type="button" className="button ghost" onClick={onClose}>
            Schließen
          </button>
        </div>
        {loading ? <p className="muted">Lade Medien-Bibliothek…</p> : null}
        {error ? <div className="alert error">{error}</div> : null}

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
            gap: '1rem',
            maxHeight: '520px',
            overflowY: 'auto',
            padding: '0.5rem 0',
          }}
        >
          {items.map((item) => {
            const isImage = item.mediaType === 'image' || item.contentType?.startsWith('image/');
            const thumbUrl = item.thumbnailUrl || item.accessUrl;

            return (
              <button
                type="button"
                key={item.mediaId}
                className="media-card selectable"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: '0.5rem',
                  borderRadius: '10px',
                  border: '1px solid #e2e8f0',
                  background: '#ffffff',
                  cursor: 'pointer',
                  textAlign: 'center',
                  transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                  outline: 'none',
                }}
                onClick={() => {
                  onSelect(item);
                  onClose();
                }}
              >
                {/* Visual Thumbnail Image Container */}
                <div
                  style={{
                    width: '100%',
                    height: '110px',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    background: '#f1f5f9',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '0.5rem',
                    position: 'relative',
                  }}
                >
                  {isImage && thumbUrl ? (
                    <img
                      src={thumbUrl}
                      alt={item.altText || item.filename}
                      loading="lazy"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : (
                    <span style={{ fontSize: '2.5rem' }}>
                      {item.mediaType === 'video' ? '🎬' : item.mediaType === 'audio' ? '🎵' : '📄'}
                    </span>
                  )}
                </div>

                <div
                  style={{
                    fontWeight: 600,
                    fontSize: '0.82rem',
                    color: '#0f172a',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '100%',
                  }}
                  title={item.filename}
                >
                  {item.filename}
                </div>
                <div className="muted small" style={{ fontSize: '0.72rem' }}>
                  {item.mediaType}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
